export const DATAQUALITY_MODULE_KEY = 'dataquality';
